const angleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [389, 512, [], '', 'M18.93 147.3a37.3 37.3 0 0 1 52.75 0L194.5 270.12 317.33 147.3a37.3 37.3 0 1 1 52.75 52.75L194.5 375.62 18.93 200.06a37.3 37.3 0 0 1 0-52.75Z']
};
const star = {
  prefix: 'far',
  iconName: 'star',
  icon: [565, 512, [], '', 'M337.23 218.7 282.5 115.32l-54.73 103.37-101.82 16.13 72.77 57.28-11.99 115.35 95.69-53.82 95.83 53.64-11.98-115.21 72.87-57.26-101.9-16.1Zm206.23 21.14-105.24 82.69 15.31 147.26a34.2 34.2 0 0 1-46.89 31.78l-124.14-69.5-120.62 67.86a34.2 34.2 0 0 1-50.41-30.13l15.3-147.27-107-84.23a34.22 34.22 0 0 1 15.61-58.4l147.92-23.43 68.63-129.62a34.2 34.2 0 0 1 61.14 0l68.62 129.62 146.64 23.16a34.22 34.22 0 0 1 15.13 60.2Z']
};
const starSolid = {
  prefix: 'fas',
  iconName: 'star-solid',
  icon: [565, 512, [], '', 'm313.07 26.85 68.62 129.62 146.64 23.16a34.22 34.22 0 0 1 15.13 60.2l-105.24 82.7 15.31 147.26a34.2 34.2 0 0 1-46.89 31.78l-124.14-69.5-120.62 67.86a34.2 34.2 0 0 1-50.41-30.13l15.3-147.27-107-84.23a34.22 34.22 0 0 1 15.61-58.4l147.93-23.43 68.62-129.62a34.21 34.21 0 0 1 61.14 0Z']
};

export { star as a, angleDown as b, starSolid as s };
//# sourceMappingURL=localIcons-B_pWoZ1u-B8hoEVqo.js.map
